import { useNavigate } from 'react-router-dom';

/**
 * "Home Page" admin tab: unlike Service Pages there's only ever one Home
 * page (a singleton, not a list), so this tab is just an index card linking
 * to the dedicated full-viewport WYSIWYG route (see ../HomePageEditor.jsx).
 * Testimonial items and case-study cards are edited on their own existing
 * tabs, not here — this tab covers the Home-page-only content around them.
 */
export default function HomePageTab() {
  const navigate = useNavigate();

  return (
    <div className="admin-panel">
      <div className="admin-panel__head">
        <div>
          <h2>Home Page</h2>
          <p className="admin-panel__desc">
            The fully inline-editable <strong>/</strong> home page (hero, solution tabs, stats, AI Solutions,
            AI Automation, case-studies headline, Why AI, How Databiqs, testimonials headline, final CTA). Use{' '}
            <strong>Edit</strong> for on-page WYSIWYG editing. Testimonial items and case-study cards are edited on
            the Testimonials / Case studies tabs.
          </p>
        </div>
      </div>

      <div className="admin-list">
        <div className="admin-list-item">
          <div>
            <strong>Home</strong>
            <br />
            <a href="/" target="_blank" rel="noopener noreferrer">
              /
            </a>
          </div>
          <div className="admin-list-actions">
            <button
              type="button"
              className="admin-btn admin-btn--ghost admin-btn--sm"
              onClick={() => navigate('/admin/home-page/edit')}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
